import { render, staticRenderFns } from "./staffDetail.vue?vue&type=template&id=4df7d3c6&scoped=true"
import script from "./staffDetail.vue?vue&type=script&lang=js"
export * from "./staffDetail.vue?vue&type=script&lang=js"
import style0 from "./staffDetail.vue?vue&type=style&index=0&id=4df7d3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df7d3c6",
  null
  
)

export default component.exports